import { staleTimes, useQuery } from '@platform/api-client';
import type { Operation, ResponseBody, TypedClient } from '@platform/openapi';
import { queryKeys, usePageContext } from '../usePageContext.ts';

export type Branding = ResponseBody<Operation<'/admin/tenant/branding', 'get'>>;
export type BrandColors = NonNullable<Branding['colors']>;

export const DEFAULT_BRAND_COLORS: BrandColors = {
  primary: '#1662C4',
  secondary: '#344767',
  accent: '#49A3F1',
};

export const BRAND_COLOR_ROLES = [
  'primary',
  'secondary',
  'accent',
] as const satisfies readonly (keyof BrandColors)[];

export const useBranding = (api: TypedClient) => {
  const { tenantId } = usePageContext();
  return useQuery({
    queryKey: queryKeys.branding(tenantId),
    queryFn: () => api.get('/admin/tenant/branding', {}),
    staleTime: staleTimes.settings,
  });
};
